import React, { useCallback } from 'react';
import { useModalStore } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import useRequireAuth from '@/hooks/useRequireAuth';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { useRouter } from 'expo-router';

// Ghost users are deprecated; the only logged-out state is "no user at
// all". The unified `useRequireAuth` opens `AuthCTAModal` for anon
// visitors before we'd otherwise pop the per-user CustomAgentModal.
const AgentsRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const router = useRouter();
  const { openModal } = useModalStore(state => state.actions);
  const requireAuth = useRequireAuth();

  const handleCreateClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    requireAuth(
      () => openModal('CustomAgentModal'),
      {
        source: 'agents_header_create',
        title: 'Sign in to create a bot',
        subtitle: 'Save a bot with its own job and instructions to your account.',
        icon: 'sparkles',
      },
    );
  }, [openModal, requireAuth]);

  const handleSearchClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    router.push('/agents/search');
  }, [router]);

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="plus"
        label={isXS ? undefined : t('nav.routes.agents.newAgent')}
        tooltip={t('nav.routes.agents.newAgentTooltip')}
        onPress={handleCreateClick}
      />
      {isXS && (
        <NavigationBarButton
          icon="magnifying-glass"
          onPress={handleSearchClick}
        />
      )}
    </NavigationBarButtonContainer>
  );
});

AgentsRouteNavigationHeaderRight.displayName = 'AgentsRouteNavigationHeaderRight';

const AgentsRouteNavigationOptions = {
  title: 'Bots',
  headerTitle: 'Bots',
  headerBackVisible: false,
  headerRight: () => <AgentsRouteNavigationHeaderRight />
};

export default AgentsRouteNavigationOptions; 